export function prepareMultiPartFormData(formValues) {
  const data = new FormData();
  data.append('file', formValues);
  return data;
}
